// Color/finish vocabulary curated from frequency analysis of real Ford 2026 CSVs.
// Keep this list in sync with the deterministic PHP grouping script in the
// `group-accessories` skill (and accessory-vault/dev.md).
export const COLOR_TOKENS: readonly string[] = [
    'Black', 'White', 'Red', 'Blue', 'Green', 'Yellow', 'Orange', 'Purple', 'Pink',
    'Gray', 'Grey', 'Gold', 'Silver', 'Beige', 'Charcoal', 'Navy', 'Burgundy', 'Tan',
    'Sand', 'Smoke', 'Clear', 'Crimson', 'Olive', 'Cream', 'Ivory', 'Khaki', 'Obsidian',
    'Copper', 'Bronze', 'Pearl', 'Onyx', 'Platinum', 'Titanium', 'Magnetic', 'Tungsten',
    'Graphite', 'Chrome', 'Polished', 'Matte', 'Satin', 'Gloss', 'Brushed', 'Stainless',
    'Metallic', 'Anodized', 'Carbon', 'Aluminum',
];
